/* eslint-disable max-classes-per-file */

import {
    AvverkningskostnadDTO,
    AvverkningskostnadRadDTO,
    SortimentSnittnettoDTO,
    SortimentSnittnettoRadDTO,
    VardeberakningResponseDTO,
    VirkesvardeDTO,
    VirkesvardeRadDTO
} from "../../dto/vardeberakning/vardeberakning-response-dto";

export class Vardeberakning {
    virkesvarde: Virkesvarde;
    avverkningskostnad: Avverkningskostnad;
    sortimentSnittnetto: SortimentSnittnetto;

    constructor(dto: VardeberakningResponseDTO) {
        this.virkesvarde = new Virkesvarde(dto.virkesvarde);
        this.avverkningskostnad = new Avverkningskostnad(dto.avverkningskostnad);
        this.sortimentSnittnetto = new SortimentSnittnetto(dto.sortimentSnittnetto);
    }
}

export class Virkesvarde {
    rader: VirkesvardeRad[];
    summa: VirkesvardeRad;

    constructor(dto: VirkesvardeDTO) {
        this.rader = dto.rader?.map(r => new VirkesvardeRad(r));
        this.summa = new VirkesvardeRad(dto.summa);
    }
}

export class VirkesvardeRad {
    handelssortimentId: number;
    handelssortimentNamn: string;
    handelssortimentsgruppNamn: string;
    handelssortimentsgruppId: number;
    m3Fub: number;
    grundpris: number;
    totaltKr: number;
    tillaggAvdrag: number;
    fsc: number;
    pefc: number;
    kvantitet: number;
    tackningsbidrag: number;
    autokompletterad: boolean;

    constructor(dto: VirkesvardeRadDTO) {
        this.handelssortimentId = dto.handelssortimentId;
        this.handelssortimentNamn = dto.handelssortimentNamn;
        this.handelssortimentsgruppId = dto.handelssortimentsgruppId;
        this.handelssortimentsgruppNamn = dto.handelssortimentsgruppNamn;
        this.m3Fub = dto.m3Fub;
        this.grundpris = dto.grundpris;
        this.totaltKr = dto.totaltKr;
        this.tillaggAvdrag = dto.tillaggAvdrag;
        this.fsc = dto.fsc;
        this.kvantitet = dto.kvantitet;
        this.tackningsbidrag = dto.tackningsbidrag;
        this.autokompletterad = dto.autokompletterad;
    }
}

export class Avverkningskostnad {
    rader: AvverkningskostnadRad[];
    summa: AvverkningskostnadRad;

    constructor(dto: AvverkningskostnadDTO) {
        this.rader = dto?.rader?.map(r => new AvverkningskostnadRad(r));
        this.summa = new AvverkningskostnadRad(dto?.summa);
    }
}

export class AvverkningskostnadRad {
    typ: string;
    krPerM3Fub: number;
    totaltKr: number;

    constructor(dto: AvverkningskostnadRadDTO) {
        this.typ = dto.typ;
        this.krPerM3Fub = dto.krPerM3Fub;
        this.totaltKr = dto.totaltKr;
    }
}

export class SortimentSnittnetto {
    rader: SortimentSnittnettoRad[];
    summa: SortimentSnittnettoRad;

    constructor(dto: SortimentSnittnettoDTO) {
        this.rader = dto.rader.map(r => new SortimentSnittnettoRad(r));
        this.summa = new SortimentSnittnettoRad(dto.summa);
    }
}

export class SortimentSnittnettoRad {
    handelssortimentNamn: string;
    handelssortimentId: number;
    handelssortimentsgruppId: number;
    handelssortimentsgruppNamn: string;
    rotvarde: number;
    tillagg: number;
    tillaggAvdrag: number;
    fsc: number;
    pefc: number;
    apris: number;
    kopeskilling: number;
    totalt: number;

    constructor(dto: SortimentSnittnettoRadDTO) {
        this.handelssortimentNamn = dto.handelssortimentNamn;
        this.handelssortimentId = dto.handelssortimentId;
        this.handelssortimentsgruppId = dto.handelssortimentsgruppId;
        this.handelssortimentsgruppNamn = dto.handelssortimentsgruppNamn;
        this.rotvarde = dto.rotvarde;
        this.tillagg = dto.tillagg;
        this.tillaggAvdrag = dto.tillaggAvdrag;
        this.fsc = dto.fsc;
        this.pefc = dto.pefc;
        this.apris = dto.apris;
        this.kopeskilling = dto.kopeskilling;
        this.totalt = dto.totalt;
    }
}
